import { h } from "preact";
import css from "./style.scss";
import cx from "classnames";
import { Text } from "preact-i18n";
import IconButton from "../icon-button";

const FieldWithButton = ({ onClick, name, value, icon }) => (
  <div class={cx(css.wrapper)}>
    <div class={cx(css.field)}>
      <div class={cx(css.name)}>{name}</div>
      <div class={cx(css.value)}>{value}</div>
    </div>
    <IconButton icon={icon} onClick={onClick} />
  </div>
);

export default FieldWithButton;
